<template>
  <div>
    <Navbar v-if="$route.name == 'oscsettings'"/>
    <!-- <Breadcrumb v-if="$route.name == 'oscsettings'" /> -->
    <div class="col-12 px-0 mx-0 mt-2">
      <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item" role="presentation">
          <button 
            class="nav-link" 
            :class="{active: activeTab === 0}"
            @click="activeTab = 0"
            type="button"
          >
            <fa-icon class="me-2" name="money-bill" />
            Pricing
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button 
            class="nav-link" 
            :class="{active: activeTab === 1}"
            @click="activeTab = 1"
            type="button"
          >
            <fa-icon class="me-2" name="envelope" />
            Invitations
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button 
            class="nav-link" 
            :class="{active: activeTab === 2}"
            @click="activeTab = 2"
            type="button"
          >
            <fa-icon class="me-2" name="tasks" />
            OSC Questions
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button 
            class="nav-link" 
            :class="{active: activeTab === 3}"
            @click="activeTab = 3"
            type="button"
          >
            <fa-icon class="me-2" name="print" />
            Report Texts
          </button>
        </li>
      </ul>
      <div class="tab-content mt-3">
        <div v-if="activeTab === 0" class="tab-pane show active">
          <div class="border-0 mx-0 ps-3 col-12">
            <div class="row">
              <div class="col-12">
                <div class="mb-3 d-flex align-items-center">
                  <label class="col-form-label" style="width: 33%; flex-shrink: 0;">VAT rate (%)</label>
                  <div style="width: 58%;">
                    <input 
                      id="osc_vat" 
                      class="form-control"
                      v-model="osc_vat"
                      @change="savepref('osc_vat',osc_vat)" 
                      autocomplete="off"
                    />
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3 d-flex align-items-center">
                  <label class="col-form-label" style="width: 33%; flex-shrink: 0;">OSC Report price per survey</label>
                  <div style="width: 58%;">
                    <input 
                      id="oscreport_price" 
                      class="form-control"
                      v-model="oscreport_price"
                      @change="savepref('oscreport_price',oscreport_price)" 
                      autocomplete="off"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="activeTab === 1" class="tab-pane show active">
          <div class="border-0 mx-auto px-0 col-12">
            <DefaultOSCMailTexts />
          </div>
        </div>
        <div v-if="activeTab === 2" class="tab-pane show active">
          <div class="border-0 mx-auto px-0 col-12">
            <Maintenance tablename="g_oscquestions" />
          </div>
        </div>
        <div v-if="activeTab === 3" class="tab-pane show active">
          <div class="border-0 mx-auto px-0 col-12">
            <Maintenance tablename="g_oscreporttexts" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import Maintenance from './Maintenance';
import DefaultOSCMailTexts from './DefaultOSCMailTexts';
import Navbar from './Navbar.vue';
// import Breadcrumb from './Breadcrumb.vue';
export default {
  name: 'OSCSettings',
  mounted() {
    this.prefs_get();
  },
  components: {
    Maintenance,
    DefaultOSCMailTexts,
    Navbar,
    // Breadcrumb,
  },
  data: function() {
    return {
      activeTab: 0,
      oscreport_price: 0,
      osc_vat: 0,
    }
  },
  methods: {
    savepref(key,value) {
      if (key.indexOf('_date') != -1) {
        value = this.format_date(value);
      }
      this.$store.dispatch('syspref_save', { key: key,value: value });
    },
    prefs_get() {
      this.$store.dispatch('syspref_fetch', { key: 'oscreport_price' })
      .then((resp) => {
        this.oscreport_price = resp.data.value;
        this.$store.dispatch('syspref_fetch', { key: 'osc_vat' })
        .then((resp) => {
          this.osc_vat = resp.data.value;
        });
      });
    },
  },
}
</script>
<style>
</style>
